<template>
  <wsp-modal>
    <v-card class="pb-5"
            flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary"
                   dark
                   dense
                   flat>
          <v-toolbar-title>
            {{ $t('reservation.delete.title')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>{{ $t('reservation.delete.text')}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="capitalize primary--text"
               flat
               @click="visible = false">
          {{ $t('global.button.cancel')}}</v-btn>

        <v-btn color="error"
               class="capitalize white--text mr-2"
               outline
               round
               @click="removeReservation">
          {{ $t('global.button.remove')}}</v-btn>
      </v-card-actions>
    </v-card>
  </wsp-modal>
</template>

<script>
import manageErrorService from '@/services/manageErrorService';
import reservationService from '@/services/reservationService';
import WspModal from '@/components/commons/WspModal';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'DeleteReservationModal',
  props: {
    booking: {
      type: Object,
      required: true
    }
  },
  components: {
    [WspModal.name]: WspModal
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    async removeReservation() {
      let params = {
        id: this.booking.id
      };

      let result = await reservationService.delete(params)

      if (result.error) {
        manageErrorService.handle(result.data);
        return;
      }

      this.visible = false;

      EventBus.$emit(keys.closeReservationDetailAndRefreshCalendar)

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('reservation.delete.toast.success'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
}
</script>
